import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";

import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { reTranslateTranslation } from "../../api/reTranslateTranslation";

export function useReTranslateTranslation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reTranslateTranslation,
    onSuccess: (response) => {
      toast.success(" The selected translation has changed to translation status ");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
